import Alert, { type AlertColor } from '@mui/material/Alert'
import { styled } from '@mui/material/styles'

const NOTIFICATION_WIDTH = 500

export const StyledAlert = styled(Alert)<{ severity: AlertColor }>(
  ({ severity, theme }) => ({
    '& .MuiAlert-action': {
      color: 'white !important',
    },
    '& .MuiAlert-icon': {
      color: `${theme.palette[severity].light} !important`,
    },
    '& .MuiAlert-message': {
      color: 'white !important',
      display: '-webkit-box',
      fontSize: '0.95rem',
      lineHeight: 1.3,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
    },
    '&.MuiAlert-root': {
      alignItems: 'center',
      backgroundColor: '#2a3f4d !important',
      borderLeft: `${theme.spacing(1.875)} solid ${
        theme.palette[severity].light
      }`,
      color: 'white !important',
      display: 'flex',
      justifyContent: 'flex-start',
      maxWidth: `${NOTIFICATION_WIDTH}px`,
      minWidth: `${NOTIFICATION_WIDTH}px`,
      paddingBottom: theme.spacing(0.75),
      paddingTop: theme.spacing(0.75),
      width: `${NOTIFICATION_WIDTH}px`,
    },
  })
)
